/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.container{
  padding-top: 32px;
  padding-bottom: 32px;
}

.banner-medium {
  @apply w-full h-auto rounded-[12px] overflow-hidden relative flex flex-col md:flex-row items-stretch md:gap-40px justify-between mx-auto   md:pl-40px;
}

.banner-medium-wrapper.pt-medium,
.banner-medium-wrapper.pt-large {
  @apply pt-0;
}

/* Job banner Styling */
.job-banner .banner-medium .banner-medium-content {
  @apply max-w-none;
}

.job-banner .banner-medium .banner-medium-asset-wrapper {
  @apply md:max-w-[20%];
}

.banner-medium .banner-medium-content {
  @apply font-poppins w-full h-auto sm:max-w-[800px] py-40px flex-1 px-16px md:px-0  flex flex-col justify-center;
}

/* .banner-medium .banner-medium-content .banner-medium-title {
  @apply text-5 sm:text-7 md:text-7 lg:text-11;
} */

.banner-medium .banner-medium-content .banner-medium-icon {
  @apply w-full h-auto max-w-[185px] object-cover;
}

.banner-medium .banner-medium-content .banner-medium-super-title {
  @apply mb-24px;
}

.banner-medium .banner-medium-content .banner-medium-description {
  @apply mt-24px;
}

.banner-medium .banner-medium-content .button {
  @apply block;
}

/* Home Banner Image Setup */
.banner-medium .banner-medium-asset-wrapper {
  @apply w-full h-auto block md:max-w-[40%] md:flex md:justify-end overflow-hidden max-h-[400px] sm:max-h-[450px] md:max-h-[100%] xl:min-h-[700px] xl:max-w-[700px] relative;
}

.banner-medium .banner-medium-asset {
  @apply w-full h-full object-cover rounded-[12px]  !important;
}

.banner-medium .banner-medium-asset-wrapper video-block {
  @apply w-full h-full;
}

.banner-medium .banner-medium-asset-wrapper video-block .video-js {
  @apply aspect-square rounded-[12px];
}

.banner-medium .banner-medium-asset-wrapper video-block .plyr__video-embed {
  @apply w-full h-full;
}

.banner-medium .banner-medium-asset-wrapper video-block .plyr__video-embed {
  @apply w-full h-full;
}

.banner-medium .banner-medium-asset-wrapper video-block .plyr__video-embed iframe {
  @apply w-full h-full min-h-[300px] rounded-[12px];
}


@media(min-width:1200px) {
  /* .banner-medium .banner-medium-content {
    @apply max-w-[50%];
  } */

  /* .banner-medium .banner-medium-content .banner-medium-title {
    @apply text-9;
  } */

}

/* Animation */
@keyframes fade-in {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 0;

  }
}

.overlay1, .overlay2 {
  @apply absolute bg-white w-full h-full top-0 left-0 z-10 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: .5s;
}

.banner-medium.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: 0s;
  }
  
  .banner-medium.animate .overlay2 {
    animation-name: fade-in;
    animation-delay: 0s;
  }

@media (min-width: 1000px) {
  .banner-medium.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: 0s;
  }
  
  .banner-medium.animate .overlay2 {
    animation-name: fade-in;
    animation-delay: 0s;
  }

}


.banner-medium.animate.content-right .overlay1 {
  animation-name: fade-in;
  animation-delay: 0s;
}

.banner-medium.animate.content-right .overlay2 {
  animation-name: fade-in;
  animation-delay: 0s;
}